import type { ThemeProps } from "models/styles/theme";
import styled from "styled-components/macro";

export const StyledPlayerContainer = styled.section<ThemeProps>`
  .pl-topic-wrapper {
    max-width: 100%;
    margin: 0;
  }
`;
